import type { FaireProductEntity } from "../../entity_types/product";

export const p_p8t6db595n: FaireProductEntity = {
  token: "p_p8t6db595n",
  type: "product",
  name: "Scented Candle & Bath Gift Box Set Creative Self-Care Gift",
  brandName: "Sparkling Extras",
  imageUrl:
    "https://cdn.faire.com/fastly/8a9bc4ca4f935f5aa67e333712621208f7f82b1df35bd686c6cd9fb5c61d59eb.jpeg",
  priceDollars: 30.99,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/7a2b5dc9a3f5d5810e2c807ae2423ee9bf8aca3bfae6694d87dc718c9a3dd9c9.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
